/*import * from 'LockScroll.js';*/
/*import {Swiper, Navigation, Thumbs} from 'swiper';*/

import {throttle, fixToIntPixel, loadLibrary} from "./Util";
//import {loadUtekaScript} from "./Uteka";
import {LIB_URL} from '../App';

const binbqScript = 'https://stada.brandquad.ru/buybutton/binbq.js';


// Сервисы Ean и Uteka
let $productOffersBtnEan = $('.js-product-offers-btn[data-ean]');
let $productOffersBtn = $('.js-product-offers-btn[data-uteka-id], .js-product-offers-btn[data-uteka-ids]');

// если есть кнопки для BtnEan-скрипта, то грузим этот скрипты на страницу
/*if ($productOffersBtnEan.length || $productOffersBtn.length) {
    $.getScript(binbqScript)
        .done(function(script, textStatus) {
            App.H.addClass('_binbq-loaded');
        })
        .fail(function( jqxhr, settings, exception ) {
            console.log('fail ajax');
        });
}*/

if ($productOffersBtnEan.length && location.hash.slice(1) === 'product-by') {
    setTimeout(() => {
        $productOffersBtnEan.click();
    }, 500);
}

$productOffersBtn.on('click', function () {
    let widget = document.querySelector('.common-popup__container-uteka .uteka-widget');
    let utekaId = $(this).attr('data-uteka-id');
    let utekaIds = $(this).attr('data-uteka-ids');
    let options = {
        // По необходимости, передайте UTM метки:
        // utmTerm: '{{ UTM term }}',
        // utmSource: '{{ UTM source }}',
        // utmMedium: '{{ UTM medium }}',
        // utmContent: '{{ UTM content }}',
        // utmCampaign: '{{ UTM campaign }}'
    };

    // если скрипт не подключен, то грузим его
    if (!App.H.is('._binbq-loaded')) {
        $.getScript(binbqScript)
            .done(function() {
                /* script, textStatus */
                App.H.addClass('_binbq-loaded');
            })
            .fail(function() {
                /* jqxhr, settings, exception  */
                console.log('fail ajax');
            });
    }

    if (utekaId) {
        options.productId = utekaId;
    }

    if (utekaIds) {
        options.productIds = utekaIds.split(',');
    }

    // if (utekaId || utekaIds) {
    //     loadUtekaScript(widget, options);
    // }
    //window.uteka.loadWidget(widget, options);
});

//if ($('.js-product-slider').length) {
if (App.H.hasClass('page-product')) {
    let $productSearch = $('.js-product-search');
    let $productSearchBtn = $('.js-product-search-btn');
    let $productSearchName = $('.js-product-search-name');
    let $productSearchResults = $('.js-product-search-results');
    let $singleProductSearchForm = $('.js-single-product-search-form');
    let $tabsWideWrap = $('.tabs.wide-wrap');

    if ($tabsWideWrap.length) {
        // позиционируем блок через margin-left, т.к. с transform не работает плагин прилипания фото
        setWideWrapSizes($tabsWideWrap);

        App.W.on('resize', throttle(function () {
            setWideWrapSizes($tabsWideWrap);
        }, 500));
    }

    /*Swiper.use([Thumbs, Navigation]);*/

    //let galleryTop = new Swiper(`.js-product-slider-top`, {
    let gallery;
    let galleryThumbs;
    let galleryItemsCount = $('.js-product-slider-thumbs').find('.swiper-slide').length;

    loadLibrary(LIB_URL.SWIPER, () => {
        galleryThumbs = new Swiper(`.js-product-slider-thumbs`, {
            spaceBetween: 9,
            slidesPerView: 3,
            loopedSlides: 3,
            /*freeMode: true,*/
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            on: {
                transitionEnd: function() {
                    fixToIntPixel(this);
                }
            }
        });

        if (galleryItemsCount > 1) {
            gallery = new Swiper('.js-product-slider-top', {
                loop: true,
                loopedSlides: 3,
                navigation: {
                    nextEl: `.js-product-slider-top-next-btn`,
                    prevEl: `.js-product-slider-top-prev-btn`,
                },
                thumbs: {
                    swiper: galleryThumbs
                }
            });

            App.H.on('product:thumbnail', function (e, index) {
                gallery.slideToLoop(index);
            });

            $('.js-product-slider-thumbs').find('.swiper-slide').on('click', function () {
                galleryThumbs.slideTo(galleryThumbs.clickedIndex - 1);
            });
        } else {
            $('.js-product-slider').addClass('_no-slider');
        }
    });

    let $productOffers = $('.js-product-offers');
    let currSku = $productOffers.val();
    //let currUtekaId = $productOffers.find(`option[value="${$productOffers.val()}"]`).data('uteka-id');

    // Если один option в селекте, то убираем стрелку и кликабельность
    if ($productOffers.find('option').length === 1) {
        $productOffers.closest('.single-product__offer').addClass('single-product__offer--single-release');
    }

    // Виджет в контенте, не в попапе
    let widgetContent = document.querySelector('.js-uteka-widget-content');

    // if (widgetContent) {
    //     App.D.ready(function() {
    //         /*window.uteka.loadWidget(widgetContent, {
    //             productId: currUtekaId,
    //         });*/
    //
    //         loadUtekaScript(widgetContent, {productId: currUtekaId});
    //     });
    // }

    $productOffers.on('change', function () {
        currSku = $productOffers.val();
        //currUtekaId = $productOffers.find(`option[value="${$productOffers.val()}"]`).data('uteka-id');

        $productOffersBtnEan.attr('data-ean', currSku);

        // Перключаем фото при изменении селекта
        if (galleryItemsCount > 1 && gallery) {
            let valOpt = $(this).children('option:selected').data('option-name');
            let slideEq = $('.js-product-slider-top').find(`.swiper-slide:not(.swiper-slide-duplicate)[data-name="${valOpt}"]`).first().data('swiper-slide-index');

            gallery.slideToLoop(slideEq, 400);
        }

        /*window.uteka.loadWidget(widgetContent, {
            productId: $productOffersBtn.attr('data-uteka-id'),
        });*/

        // if (currUtekaId) {
        //     loadUtekaScript(widgetContent, {productId: $productOffersBtn.attr('data-uteka-id')});
        // }
    });

    $('.js-instruction-btn').on('click', function (e) {
        let $instructionPopup = $('[data-name="instruction"]');

        if ($(this).hasClass('yes-btn')) {
            window.open($('[data-popup="instruction"]').attr('href'), '_blank');
        }

        $instructionPopup.find('.js-common-popup-close').trigger('click');

        e.preventDefault();
    });

    $productSearchBtn.on('click', function (e) {
        $productSearch.addClass('_open');
        $productSearch.find('input[type="text"]').focus();

        e.preventDefault();
    });

    $productSearchName.on('input', function () {
        inputProductSearchName();
    });

    App.D.on('mouseup', function (e) {
        if (!$productSearch.is(e.target) && $productSearch.has(e.target).length === 0) {
            $productSearch.removeClass('_open');
        }
    });

    App.D.on('click', '.js-popup-close', function (e) {
        $('.bqbin-modal').trigger('click');

        e.preventDefault();
    });


    const inputProductSearchName = throttle(() => {
        if ($productSearchName.val().length > 3) {
            getSearchResults();
        } else {
            $productSearchResults.removeClass('_show');
        }
    }, 500);

    function getSearchResults() {
        $.ajax({
            url: $singleProductSearchForm.data('search-url'),
            method: $singleProductSearchForm.attr('method') || 'GET',
            data: $singleProductSearchForm.serialize(),
            success: (response) => {
                $productSearchResults.html(response.results);
                $productSearchResults.addClass('_show');
            },
            error: () => {
                console.log('Ошибка получения данных');
            }
        });
    }

    /*$productOffersBtn.on('click', function (e) {
        let _url = $productOffersBtn.data('url');
        let _type = $productOffersBtn.data('type');

        _url += `?${$productOffers.attr('name')} = ${$productOffers.val()}`;
        getPrices(_url, _type);

        e.preventDefault();
    });*/

    /*function getPrices(_url, _type) {
        $.ajax({
            type: 'GET',
            url: _url,
            dataType: 'html',
            success: (response) => {
                let $pricePopup = $('.js-price-popup');

                $pricePopup.html($(response).html());
                $pricePopup.addClass('_open');
            },
            error: () => {
                console.log('Не могу получить данные о наличии в этом городе');
            }
        });
    }*/

    // открываем галерею по ссылке на номер слайда
    App.D.on('click', '[data-open-image]', function (e) {
        e.preventDefault();

        const index = parseInt($(this).attr('data-open-image')) - 1;
        const $swiper = $('.js-product-slider-top');

        if ($swiper.length && $swiper[0].swiper) {
            const swiper = $swiper[0].swiper;

            $(swiper.slides[index + swiper.loopedSlides]).find('.js-popup-gallery-item').click();
        }
    });
}


function setWideWrapSizes($tabsWideWrap) {
    const wrapWidth = $tabsWideWrap.outerWidth();

    if (App.W.outerWidth() >= 1024) {
        $tabsWideWrap.css({
            'margin-left': -wrapWidth/2
        });
        $('.wrap-page')[0].scrollLeft = 0;
    } else {
        $tabsWideWrap.removeAttr('style');
    }
}
